module.exports = __webpack_public_path__ + "static/media/logo.b7b34a8c.png";